<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="9000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
              
                <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Place Order</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <!-- 1000001621 -->
                    <v-col cols="12" sm="3">
                        <p><b>Enter Student PRN*</b></p>
                        <!-- 1000001621  -- {{wallet_grace_amount}} -->
                        <!-- G20210197 -->
                        <v-text-field outlined dense type="text" ref='focusMe' v-model="prn" value="1000001621" @keydown="handleKeyDown" autofocus></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                        <p class="padding-bot"><b></b></p>
                        <br />
                        <v-btn class="toolbar" outlined dense rounded :loading="loader" @click="fetchStudentData()">
                            Fetch</v-btn>
                    </v-col>
                </v-row>
                <v-row justify="center" allign="center" v-if="learner_details != ''" dense>
                  <v-col cols="12" sm="2" md="2"></v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="" md="6">
                                <p><b>Standard : </b> {{ learner_details[0].standard }}</p>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>DOB : </b> {{ learner_details[0].dob }}</p>
                            </v-col>
                            </v-row>
                             <v-row justify="center" dense>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>Mother Name : </b> {{ learner_details[0].mother_name }}</p>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>Wallet Balance : </b> <b style="font-size: larger;" class="flash">{{ learner_details[0].balance }}</b> </p>
                            </v-col>
                            </v-row>
                            <v-row justify="center" dense>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>Parent Contact : </b> {{ learner_details[0].mobile_no }}</p>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>Parental Control : </b><v-icon color="black"
                                        @click="showParentalControlList()">mdi-eye</v-icon></p>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                                <v-col cols="12" sm="6" md="6">
                                    <p><b>Allergy: </b> {{ learner_details[0].allergy }}</p>
                                </v-col>
                                 <v-col cols="12" sm="6" md="6">
                                 </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <center>
                            <v-img width="150" :src="awspath + learner_details[0].photo_url" aspect-ratio="1"
                                class="grey lighten-2" style="border: 1px solid black;"></v-img>
                            <p><b>{{ learner_details[0].learner }}</b></p>
                        </center>
                    </v-col>
                    <v-col cols="12" sm="1" md="1"></v-col>
                </v-row>
                </v-card>
                 <v-card class="box" v-if="learner_details != ''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Choose Category</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <b class="mr-2">View Menu Card </b> <v-icon color="white" @click="getCanteenManuCard()">mdi-eye</v-icon>
                </v-toolbar>
                <!-- {{menu_category_list}} -->
                 <v-row style="height: 40px; align-content: center;" justify="center" dense v-if="menu_category_list!=''">
                        <div class="mr-5"><b>Select Menu Category</b> </div>
                        <span v-for="(inst, index) in menu_category_list" :key="index" class="radio-container">
                            <input type="radio" class="radiospace" v-model="canteen_menu_category" @change="getMenus()" v-bind:value="inst"/>
                            {{ inst.name }}
                    </span>
                </v-row>

                 <v-row v-if="learner_details != ''" justify="center" dense>
                    <v-col cols="12" sm="8">
                        <v-card class="box" v-if="canteen_menu_list!=''">
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong>
                                        Menu Item
                                    </strong>
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-row justify="center" dense>
                                <v-col cols="12" sm="3">
                                    <p><b>Canteen Menu:</b></p>
                                     <v-text-field outlined dense type="text" disabled v-model="menuitem" />

                                    <!-- <v-autocomplete color="#0F2027" @change="setrate(menuitem)" return-object dense rounded
                                        required v-model="menuitem" :items="canteen_menu_list" item-text="name"
                                        item-value="id" label="Menu" outlined /> -->
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <p><b>Rate In Rs.:</b></p>
                                    <v-text-field outlined dense type="text" disabled v-model="rate"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <p><b>Quantity:</b></p>
                                    <v-text-field outlined dense type="number" disabled v-model="quantity"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2" v-if="quantity != null">
                                    <p class="padding-bot"><b></b></p><br>
                                    <v-btn class="toolbar" outlined dense rounded :loading="loader"
                                        @click="savePlaceOrder()">Place Order</v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
              </v-card>

                <!-- {{temp_balance}} -->
                  <v-card class="box" v-if="menu_cart != ''">
                    <v-data-table v-if="menu_cart != ''" class="elevation-1 mytable" dense :headers="menu_cart_headers"
                        :items="menu_cart">
                        <template v-slot:top>
                            <v-toolbar dense flat class="toolbar">
                                <v-toolbar-title>Cart</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <br />
                        </template>
                        <template v-slot:[`item.delete`]="{ item }">
                            <v-btn text icon color="grey lighten-1" @click="deleteRow(item.index)"><v-icon>
                                    mdi-delete</v-icon></v-btn>
                        </template>
                    </v-data-table>
                    <v-row justify="center" dense>
                        <v-btn class="toolbar" outlined dense rounded :loading="loader" @click="savePlaceOrder()">Place
                            Order</v-btn>
                    </v-row>
                  </v-card>
                    <v-card class="box" v-if="student_canteen_order_list != ''">
                            <v-data-table v-if="student_canteen_order_list != ''" class="elevation-1 mytable" dense
                                :headers="student_canteen_order_headers" :items="student_canteen_order_list">
                                <template v-slot:top>
                                    <v-toolbar flat dense class="toolbar">
                                        <v-toolbar-title>Today's Orders</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <br />
                                </template>
                                <template v-slot:[`item.cancel`]="{ item }">
                                    <v-btn @click="cancelOrder(item)" class="mt-1 mb-1 v-icon-size" outlined rounded small
                                        color="red">Cancel</v-btn>
                                </template>
                                <template v-slot:[`item.receipt`]="{ item }">
                                    <v-tooltip top color="warning">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs" v-on="on"
                                                @click="print(item)">
                                                <!-- <v-icon color="warning">mdi-printer</v-icon>{{ item.orderid }}</v-btn -->
                                                <v-icon color="warning">mdi-printer</v-icon>Print</v-btn>
                                        </template>
                                        <span> Print Fee Receipt!!! </span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                    </v-card>

             

            <v-dialog v-model="dialog_cancel" persistent max-width="1200px" transition="dialog-bottom-transition">
                <v-card>
                    <v-card class="box">
                        <v-toolbar dense flat class="toolbar">
                            <v-toolbar-title>Cancel Order</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <v-data-table dense class="elevation-1 mytable" :headers="canteen_cancel_order_headers"
                                :items="canteen_cancel_order_list">
                                <template v-slot:[`item.cancel`]="{ item }">
                                    <v-btn @click="saveCancelOrder(item)" outlined rounded small class="ma-1 v-icon-size"
                                        color="red">Cancel</v-btn>
                                </template>
                            </v-data-table>
                            <v-row justify="center" dense v-if="canteen_cancel_order_list != ''">
                                <v-btn @click="saveCancelAllOrder()" class="ma-4 v-icon-size" rounded outlined small
                                    color="red">Cancel Whole Order</v-btn>
                            </v-row>
                        </v-card-text>
                        <br />
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="dialog_cancel = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-dialog>
            <v-dialog v-model="show_menu" persistent max-width="1200px" transition="dialog-bottom-transition">
                <v-card>
                    <v-card class="box">
                        <v-toolbar flat class="toolbar">
                            <v-toolbar-title>Parental Control Menu List</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <v-data-table :headers="menu_headers" :items="parental_control_list"> </v-data-table>
                        </v-card-text>
                        <br />
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="show_menu = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_print" persistent max-width="1200px" transition="dialog-bottom-transition">
                <v-card>
                    <v-card class="box" v-if="order_details != ''">
                        <v-toolbar dense flat class="toolbar">
                            <v-toolbar-title>Print</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>

                            <v-card>
                                <v-simple-table dense class="elevation-1 table-container">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th colspan="4">
                                                    <center><strong>Canteen Receipt</strong></center>
                                                </th>
                                            </tr>
                                            <tr>
                                                <td colspan="4">
                                                    <center><strong><b>WWS Canteen</b></strong></center>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">Date. : {{ order_details[0].transaction_date }}</td>
                                                <td colspan="2">Order Id : {{ order_details[0].orderid }}</td>
                                            </tr>
                                            <tr>
                                                <th>Menu</th>
                                                <th>Rate</th>
                                                <th>Quantity</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in order_details" :key="item.id">
                                                <td>{{ item.canteenmenu }}</td>
                                                <td>{{ item.rate }}</td>
                                                <td>{{ item.quantity }}</td>
                                                <td>{{ item.amount }}</td>
                                            </tr>
                                        </tbody>
                                        <tr>
                                            <td colspan="3">
                                            </td>
                                            <td colspan="1">
                                                <center><strong>Total In Rs. {{ total_order_amount }}</strong></center>
                                            </td>
                                        </tr>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-card-text>
                        <v-row justify="center" dense>
                            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="printreceipt()"> <v-icon
                                    left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                        </v-row>

                        <br />
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="dialog_print = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_menu_card" style="margin-top: 10%" fullscreen hide-overlay
                transition="dialog-top-transition">
                <v-card class="mx-auto">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Canteen Menu</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="dialog_menu_card = false"><v-icon>mdi-close</v-icon>Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                            hide-details></v-text-field>
                    </v-card-title>
                    <br />
                    <v-card-text>
                        <v-data-table :headers="menu_headers" :items="all_canteen_menu_list" :search="search" multi-sort
                            class="elevation-1" :items-per-page="-1">
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-dialog>


        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    components: {
    "place-meal-order": () => import('./PlaceMealOrder')
    },
    data: () => ({
        order_details: [], dialog_print: false,
        loader: false,
        search: "",
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        prn: "",
        learner_details: [],
        show_stud_data: false,
        parental_control_list: [],
        show_menu: false,
        radios: null,
        radios_category: null,
        canteen_menu_list: [],

        menuitem: null,
        quantity: 1,
        rate: 0,
        index: 0,
        srno: 1,
        student: "",
        orderid: "",
        canteen_order_list: [],
        student_canteen_order_list: [],
        dialog_cancel: false,
        cancel_order_id: "",
        canteen_cancel_order_list: [],
        menuid: "",menu_id:"",
        menuids: [],
        quantities: [],
        rates: [],
        ids: [],
        awspath: "", total_cart_value: 0, temp_balance: 0,
        headers: [
            { text: "Title", value: "title" },
            { text: "Description", value: "description" },
        ],
        menu_headers: [
            // { text: "SR No", value: "count" },
            { text: "Menu Id", value: "menuid" },
            { text: "Menu type", value: "canteenmenutype" },
            { text: "Menu Category", value: "canteenmenucategory" },
            { text: "Name", value: "name" },
        ],
        menu_cart_headers: [
            // { text: "Index", value: "index" },
            { text: "SR No", value: "srno" },
            { text: "Menu Id", value: "menuid" },
            { text: "Menu Item", value: "menuitem" },
            { text: "Rate", value: "rate" },
            { text: "Quantity", value: "menuquantity" },
            { text: "Total", value: "total" },
            { text: "Delete", value: "delete" },
        ],
        canteen_order_headers: [
            { text: "SR No", value: "count" },
            { text: "Menu", value: "canteenmenu" },
            { text: "Rate", value: "rate" },
            { text: "Quantity", value: "quantity" },
            { text: "Total", value: "amount" },
        ],
        student_canteen_order_headers: [
            { text: "SR No", value: "count" },
            { text: "Order Id", value: "orderid" },
            { text: "Menu", value: "canteenmenu" },
            { text: "Rate", value: "rate" },
            { text: "Quantity", value: "quantity" },
            { text: "Total", value: "amount" },
            { text: "Cancel", value: "cancel" },
            { text: "Receipt", value: "receipt" },
        ],
        menu_cart: [
            // srno:[],menuitem:[],menuid:[],rate:[],menuquantity:[],total:[]
        ],
        canteen_cancel_order_headers: [
            { text: "SR No", value: "count" },
            { text: "Order Id", value: "orderid" },
            { text: "Menu", value: "canteenmenu" },
            { text: "Rate", value: "rate" },
            { text: "Quantity", value: "quantity" },
            { text: "Total", value: "amount" },
            { text: "Cancel", value: "cancel" },
        ],
        all_canteen_menu_list: [], dialog_menu_card: false, total_order_amount: 0,
        menu_category_list:[],canteen_menu_category:"",wallet_grace_amount:0,
    }),
    methods: {
        async handleKeyDown(event) {
        if (event.key === 'Enter') {
            this.fetchStudentData()
        }
        },
        getMenus(){
            const data = {
                canteen_menu_category: this.canteen_menu_category.id,
                learner:this.learner_details[0].id
            };
            this.overlay = true;
            axios
                .post("/Canteen/getMenu", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.canteen_menu_list = res.data.canteen_menu_list;
                        this.menuitem=this.canteen_menu_list[0].name
                        this.rate=this.canteen_menu_list[0].rate,
                        this.menu_id=this.canteen_menu_list[0].id

                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        printreceipt() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        print(item) {
            this.total_order_amount = 0
            this.order_details = [];
            const data = {
                orderid: item.orderid,
            };
            this.overlay = true;
            axios
                .post("/Canteen/getOrderDetails", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.order_details = res.data.canteen_order_list;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.dialog_print = true;
                    this.getOrderDetailsTotal()
                });
        },
        getOrderDetailsTotal() {
            for (var i = 0; i < this.order_details.length; i++) {
                this.total_order_amount += this.order_details[i].amount
            }
            return this.total_order_amount
        },
        getCanteenManuCard() {
            this.overlay = true;
            axios
                .post("/Canteen/getCanteenManuCard")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.all_canteen_menu_list = res.data.all_canteen_menu_list;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.dialog_menu_card = true;
                });
        },
        cancelOrder(item) {
            this.dialog_cancel = true;
            this.cancel_order_id = item.orderid;
            const data = {
                orderid: this.cancel_order_id,
            };
            this.overlay = true;
            axios
                .post("/Canteen/getOrderDetails", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.canteen_cancel_order_list = res.data.canteen_order_list;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        saveCancelOrder(item) {
            const data = {
                orderid: item.id,
            };
            this.overlay = true;
            axios
                .post("/Canteen/saveCancelOrderDetails", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.canteen_cancel_order_list = res.data.canteen_order_list;
                        // this.canteen_order_list = res.data.canteen_order_list;
                        this.showSnackbar("green", "Order Cancelled Successfully..");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.fetchStudentData()
                });
        },
        saveCancelAllOrder() {
            const data = {
                orderid: this.cancel_order_id,
            };
            this.overlay = true;
            axios
                .post("/Canteen/saveCancelAllOrderDetails", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.canteen_cancel_order_list = res.data.canteen_order_list;
                        // this.canteen_order_list = res.data.canteen_order_list;
                        this.showSnackbar("green", "Order Cancelled Successfully..");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.fetchStudentData()
                });
        },
        deleteRow(index) {
            // alert(index) 
            this.menu_cart.splice(index, 1);
            this.arrangeCartvalues();
        },
        arrangeCartvalues() {
            var ind = 0
            for (var i = 0; i < this.menu_cart.length; i++) {
                this.menu_cart[i].index = ind
                this.menu_cart[i].srno = ind + 1
                ind += 1
            }
        },
        getOrderDetails() {
            this.canteen_order_list = []
            if (this.orderid == null || this.orderid == '') {
                return
            }
            const data = {
                orderid: this.orderid,
            };
            this.overlay = true;
            axios
                .post("/Canteen/getOrderDetails", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.canteen_order_list = res.data.canteen_order_list;

                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getCanteenMenu() {
            if (this.menuid == null || this.menuid == '') {
                return
            }
            const data = {
                menuid: this.menuid,
                student: this.learner_details[0].id
            };
            this.overlay = true;
            axios
                .post("/Canteen/getCanteenMenu", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        //(this.canteen_menu_list = res.data.canteen_menu_list)
                        this.menuitem = res.data.canteen_menu_list[0].name
                        this.rate = res.data.canteen_menu_list[0].rate
                        this.item_id = res.data.canteen_menu_list[0].id
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        this.menuid = ""
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        clearData() {
            this.menu_cart = [],
            this.quantity = 1,
            //this.rate = 0,
            this.student = [],
           // this.menuitem = [],
            this.menuids = []
            this.quantities = []
            //this.rates = []
            //this.ids = [],
            this.radios = null
            //this.menu_id="",
            this.total_cart_value=0
        },
        getTotalcartValue(){
             this.total_cart_value=0
             if(this.quantity<=0){
                this.showSnackbar("red", "Please Add Quantity Greater Than 0");
                return
             }
            this.total_cart_value=this.rate*this.quantity

            // //  for (var i = 0; i < this.menu_cart.length; i++) {
            //     this.total_cart_value += parseFloat(this.menu_cart[i].menuquantity * this.menu_cart[i].rate);
            //  }
             return  this.total_cart_value
        },

        savePlaceOrder() {
            //this.total_cart_value = 0
            // +this.wallet_grace_amount
             if(this.quantity<=0){
                this.showSnackbar("red", "Please Add Quantity Greater Than 0");
                return
             }
            if (this.learner_details[0].balance+this.wallet_grace_amount < 0) {
                this.showSnackbar("red", "Insufficient Balance Wallet...Please Recharge Your Wallet...");
                return;
            }
             this.getTotalcartValue();
            //   alert("this.total_cart_value"+this.total_cart_value)
            // alert("balance"+this.learner_details[0].balance)

             if (this.learner_details[0].balance+this.wallet_grace_amount < this.total_cart_value) {
                this.showSnackbar("red", "Insufficient Balance Wallet To Complete This Order...Please Recharge Your Wallet...");
                return;
            }
           
             //this.total_cart_value=0
            // for (var i = 0; i < this.menu_cart.length; i++) {
            //     this.menuids.push(this.menu_cart[i].menuid);
            //     this.quantities.push(this.menu_cart[i].menuquantity);
            //     this.rates.push(this.menu_cart[i].rate);
            //     this.ids.push(this.menu_cart[i].id);
            //     //this.total_cart_value += parseFloat(this.menu_cart[i].menuquantity * this.menu_cart[i].rate);
            // }
           
            const data = {
                ids: this.menu_id,
                //menuids: this.menuids,
                rates: this.rate,
                quantities: this.quantity,
                student: this.learner_details[0].id,
                total_cart_value: this.total_cart_value
            };
            this.overlay = true;
            //return
            axios
                .post("/Canteen/savePlaceOrder", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", res.data.snackbar);
                        //this.clearData();
                        this.fetchStudentData();
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        this.master_present = true;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.$refs.focusMe.focus();
                     this.clearData();
                });
        },
        savePlaceOrderFromOrder() {
            if (this.learner_details[0].balance <= 0) {
                this.showSnackbar("red", "Insufficient Balance Wallet...Please Recharge Your Wallet...");
                return;
            }
            for (var i = 0; i < this.canteen_order_list.length; i++) {
                this.menuids.push(this.canteen_order_list[i].canteenmenuid);
                this.quantities.push(this.canteen_order_list[i].quantity);
                this.rates.push(this.canteen_order_list[i].rate);
                this.ids.push(this.canteen_order_list[i].canteenmenu_id);
            }
            const data = {
                ids: this.ids,
                menuids: this.menuids,
                rates: this.rates,
                quantities: this.quantities,
                student: this.learner_details[0].id,
            };
            this.overlay = true;
            axios
                .post("/Canteen/savePlaceOrder", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Order Placed Successfully..");

                        this.clearData();
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        this.master_present = true;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        addToCartOrder() {
            if (this.menu_cart.length <= 0) {
                this.index = 0
            }
            this.arrangeCartvalues();
            //   this.temp_balance-=this.quantity*this.rate
            // if(this.temp_balance<=0){
            //      this.showSnackbar("red", "Insufficient Balance...Cannot Add Menu To Cart...");
            //      this.temp_balance=this.learner_details[0].balance
            //      return
            // }

            this.srno = this.menu_cart.length + 1
            this.index = this.menu_cart.length
            var i1 = 1
            for (var i = 0; i < this.canteen_order_list.length; i++) {
                this.menu_cart.push({
                    index: this.index,
                    srno: this.srno,
                    id: this.canteen_order_list[i].canteenmenu_id,
                    menuitem: this.canteen_order_list[i].canteenmenu,
                    menuid: this.canteen_order_list[i].canteenmenuid,
                    rate: this.canteen_order_list[i].rate,
                    menuquantity: this.canteen_order_list[i].quantity,
                    total: this.canteen_order_list[i].quantity * this.canteen_order_list[i].rate,
                });
                i1++
                this.index += 1
                this.srno += 1
            }
        },
        addToCart() {
            if (this.quantity <= 0) {
                this.showSnackbar("red", "Please Enter Quantity...");
                return
            }
            if (this.menuitem == '' || this.menuitem == null) {
                this.showSnackbar("red", "Please Select menu!!!");
                return
            }
            this.arrangeCartvalues();
            if (this.menu_cart.length <= 0) {
                this.index = 0
            }
            //this.temp_balance-=this.quantity*this.rate
            // if(this.temp_balance<=0){
            //      this.showSnackbar("red", "Insufficient Balance...Cannot Add Menu To Cart...");
            //      return
            // }
            this.srno = this.menu_cart.length + 1
            this.index = this.menu_cart.length
            this.menu_cart.push({
                index: this.index,
                srno: this.srno,
                id: this.menuitem.id,
                menuitem: this.menuitem.name,
                menuid: this.menuitem.menuid,
                rate: this.menuitem.rate,
                menuquantity: this.quantity,
                total: this.quantity * this.menuitem.rate,
            });
            this.index += 1;
            this.srno += 1;

            this.menuitem = null
            this.rate = 0
            this.quantity = 1
        },
        addToCartMenuId() {
            // alert(this.menuid)
            if (this.menuid == '' || this.menuid == null) {
                this.showSnackbar("red", "Please Select menu!!!");
                return
            }
            if (this.quantity <= 0) {
                this.showSnackbar("red", "Please Enter Quantity...");
                return
            }
            this.arrangeCartvalues();
            if (this.menu_cart.length <= 0) {
                this.index = 0
            }
            this.srno = this.menu_cart.length + 1
            this.index = this.menu_cart.length

            // var res= this.setBalance();
            // if(res == false){
            //      this.showSnackbar("red", "Insufficient Balance...Cannot Add Menu To Cart...");
            //      return
            // }
            if (this.menuid != '' || this.menuid != null) {
                this.menu_cart.push({
                    index: this.index,
                    srno: this.srno,
                    id: this.item_id,
                    menuitem: this.menuitem,
                    menuid: this.menuid,
                    rate: this.rate,
                    menuquantity: this.quantity,
                    total: (this.quantity * this.rate)
                });
            }
            //vikas
            this.menuitem = null
            this.menuid = null
            this.rate = 0
            this.quantity = 1
            //
            this.index += 1
            this.srno += 1
        },
        setBalance() {
            var res = true
            var bal = this.temp_balance
            var amt = 0

            amt = this.quantity * this.rate

            if (this.menu_cart.length == 0) {
                this.temp_balance -= this.quantity * this.rate
            } else {
                for (var i = 0; i < this.menu_cart.length; i++) {
                    this.temp_balance -= this.menu_cart[i].total
                }
            }
            if (this.temp_balance <= 0) {
                // this.showSnackbar("red", "Insufficient Balance...Cannot Add Menu To Cart...");
                res = false
                this.temp_balance = bal
            }
            return res
        },
        setrate(menu) {
            //alert(menu)
            this.rate = menu.rate;
        },
        showParentalControlList() {
            this.parental_control_list = this.learner_details[0].canteen_menu_list;
            this.show_menu = true;
        },
        fetchStudentData() {
            this.menu_cart = []
           if(this.prn=='' || this.prn==null){
                this.showSnackbar("red", "Please Enter PRN...");
                return
            }
            const data = {
                prn: this.prn,
            };
            this.overlay = true;
            axios
                .post("/Canteen/fetchStudentData", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        (this.learner_details = res.data.learner_details),
                           // (this.canteen_menu_list = res.data.canteen_menu_list),
                            (this.student_canteen_order_list = res.data.student_canteen_order_list)
                        this.temp_balance = this.learner_details[0].balance
                        this.wallet_grace_amount=res.data.wallet_grace_amount
                        //  (this.student = this.learner_details[0].id)
                        this.show_stud_data = true
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        this.master_present = true;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/Canteen/getCanteenMenuCategory")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        // this.show_stud_data = true;
                        this.menu_category_list=res.data.menu_category_list
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    created() {
        this.awspath = localStorage.getItem("awspath");
        this.tenant = localStorage.getItem("EPS-tenant");
    },
    mounted() {
        this.onLoad();
        this.$refs.focusMe.focus()
    },
    watch: {},
};
</script>
<style scoped>
 .radiospace {
        margin: 0.2rem !important;
        padding-top: 0.5rem !important;
    }
@media all and (max-width: 900px) {
    .padding-bot {
        padding: 8px;
    }
}

.mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    img {
        width: 100% !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
    }

    body,
    tr,
    th,
    td {
        font-size: xx-large !important;
        font-weight: bold !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    @page {
        margin-top: none;
        padding-top: none;
        size: 27.5in 18.5in;
    }

    table,
    td,
    tr,
    th {
        text-align: center !important;
        margin: none;
        padding: 1rem !important;
        font-size: xx-large !important;
        font-weight: bold !important;
        border-bottom: 1px solid black;
        border: 1px solid black;
    }
}

.table-container {
    overflow-x: hidden;
    overflow: hidden;
}
   .flash {
   animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {color: red;}
    to {color: white;}
}

</style>
